<template>
  <BaseModal id="ModalDeleteCriterion" :title="title" :show.sync="$show">
    <p class="text-dark small">
      {{ subTitle }}
    </p>

    <b-alert
      v-if="criteria && criteria.title"
      show
      class="d-flex align-items-center pl-2 align-content-center"
      variant="danger"
    >
      <span>
        <strong class="d-block ml-3">{{ criteria.title }}</strong>
      </span>
    </b-alert>
    <p class="text-dark small">
      {{ description }}
    </p>
    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>
      <b-button variant="danger" @click="handleDelete()">
        <span v-if="!isLoading">{{ deleteActionText }}</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin';
import BaseModal from '@/components/base-components/BaseModal';

export default {
  components: {
    BaseModal
  },

  mixins: [notificationMixin],

  props: {
    criteria: {
      type: Object,
      default: () => {}
    },

    show: {
      type: [Boolean, Number],
      default: false
    },

    title: {
      type: String,
      default: 'Delete this criterion'
    },

    subTitle: {
      type: String,
      default: 'Are you sure that you want to delete this criterion?'
    },

    description: {
      type: String,
      default: 'Click at the "Delete" button to delete this criterion.'
    },

    deleteActionText: {
      type: String,
      default: 'Delete'
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },

  methods: {
    hide() {
      this.$bvModal.hide(`ModalDeleteCriterion`);
    },
    async handleDelete() {
      try {
        this.isLoading = true;
        this.$emit('emitDeleteCriterion');
        this.isLoading = false;
        this.hide();
      } catch (e) {
        console.log(e);
        this.notiError();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
